import _ from 'lodash';
import Fuse from 'fuse.js';

import * as api from '../../api';

import { useState } from 'react';
import { TextInput } from '../TextInput';
import { DropDownList } from './DropDownList';
import { Icon } from '@vivaahealth/design-system';
import { PharmacyWithDistance } from './types';

interface Props {
  sortedPharmacies: PharmacyWithDistance[];
  patientPharmacies: api.Pharmacy.PrevisitPharmacy[];
  setSelectedPharmacyId: (id: string) => void;
  pending?: boolean;
}
export const Selector = ({
  sortedPharmacies,
  patientPharmacies,
  setSelectedPharmacyId,
  pending,
}: Props) => {
  const [inputValue, setInputValue] = useState('');
  const fuseOptions = {
    includeScore: true,
    ignoreLocation: true,
    keys: ['name', 'address', 'city'],
    threshold: 0.5,
  };
  const fuse = new Fuse(sortedPharmacies, fuseOptions);
  const sorted = _.sortBy(fuse.search(inputValue), (result) => {
    const defaultDistance = 5000;
    return (
      (result.item.distance || defaultDistance) + (result.score || 1) * 500
    );
  }).map((result) => result.item);

  return (
    <>
      <TextInput
        style={{
          borderColor: 'red',
        }}
        onChange={(e) => setInputValue(e.target.value)}
        value={inputValue}
        InputProps={{
          startAdornment: (
            <Icon.Search
              style={{ marginLeft: '0.5rem', marginRight: '0.5rem' }}
              stroke={'#737373'}
              size="medium"
              alt="search"
            />
          ),
          color: 'primary',
          style: {
            borderColor: 'red',
          },
        }}
      />
      <DropDownList
        pending={pending}
        matchedPharmacies={sorted}
        nearByPharmacies={sortedPharmacies.slice(0, 3)}
        patientPharmacies={patientPharmacies}
        inputValue={inputValue}
        onSelect={setSelectedPharmacyId}
      />
    </>
  );
};
